module.exports = __webpack_public_path__ + "static/media/bank.d7e35c52.svg";